import { render, staticRenderFns } from "./documentProcessingFormDetailPhone.vue?vue&type=template&id=24e787f0&scoped=true&"
import script from "./documentProcessingFormDetailPhone.vue?vue&type=script&lang=js&"
export * from "./documentProcessingFormDetailPhone.vue?vue&type=script&lang=js&"
import style0 from "./documentProcessingFormDetailPhone.vue?vue&type=style&index=0&id=24e787f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e787f0",
  null
  
)

export default component.exports